import { z } from 'zod';

export const CakeToOrderPortionModelSchema = z.object({
    value: z.number(),
    meassure: z.string(),
    description: z.any().optional().nullable(),
    weight: z.number(),
    price: z.number(),
    pricePrefix: z.string().optional().nullable(),
    currency: z.object({
        uid: z.string(),
        name: z.string(),
        abbreviation: z.string(),
    }).optional().nullable(),
});

export type CakeToOrderPortionModel = z.infer<typeof CakeToOrderPortionModelSchema>;
